import { PopupManager } from 'managers/PopupManager'

export default class BalanceModel {
  constructor() {
    this._balance = 0
  }

  set(value) {
    if (typeof value === 'number' && !isNaN(value)) {
      this._balance = isNaN(value) || value < 0 ? 0 : value
    }
    else {
      PopupManager.show('serverError')
    }
  }

  get() {
    return this._balance
  }
}
